import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/blocks.action'
import { destroyScormBlock } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

async function handleDestroyScormBlock(ScormBlockId: number) {
  return await destroyScormBlock(ScormBlockId)
}

function* destroyScormBlockEffectSaga(action: any) {
  try {
    const {
      payload: { scormBlockId, lessonId },
    } = action
    yield call(handleDestroyScormBlock, scormBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyScormBlockWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_SCORM_BLOCK, destroyScormBlockEffectSaga)
}
